import { CheckOutlined, CloseOutlined, ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons';
import { Button, Spin, Table } from 'antd';
import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store';

pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.js', import.meta.url).toString();

const ReviewTab: React.FC<any> = ({ isViewingPdfOffer }) => {
  const offer = useSelector((state: RootState) => state?.models?.offer);

  const [numPages, setNumPages] = useState<number | null>(null);
  const [scale, setScale] = useState(1.5);

  const columns = [
    {
      title: 'Validation Status',
      dataIndex: 'content',
      key: 'content',
    },
  ];

  const dataSource = [
    {
      key: '1',
      content: (
        <>
          {offer.companyId ? (
            <CheckOutlined style={{ color: 'green', marginRight: 8 }} />
          ) : (
            <CloseOutlined style={{ color: 'red', marginRight: 8 }} />
          )}
          Client
        </>
      ),
    },
    {
      key: '2',
      content: (
        <>
          {offer.enumOfferStatusId ? (
            <CheckOutlined style={{ color: 'green', marginRight: 8 }} />
          ) : (
            <CloseOutlined style={{ color: 'red', marginRight: 8 }} />
          )}
          Status
        </>
      ),
    },
    {
      key: '3',
      content: (
        <>
          {offer.date ? (
            <CheckOutlined style={{ color: 'green', marginRight: 8 }} />
          ) : (
            <CloseOutlined style={{ color: 'red', marginRight: 8 }} />
          )}
          Data Oferta
        </>
      ),
    },
    {
      key: '4',
      content: (
        <>
          {offer.offerWorkPlaceItems?.length > 0 ? (
            <CheckOutlined style={{ color: 'green', marginRight: 8 }} />
          ) : (
            <CloseOutlined style={{ color: 'red', marginRight: 8 }} />
          )}
          Dispozitive
        </>
      ),
    },
  ];

  if (isViewingPdfOffer) {
    return <Spin size='large' style={{ position: 'fixed', left: '50%', top: '50%' }} />;
  }
  const handleZoomIn = () => {
    setScale((prevScale) => Math.min(prevScale + 0.2, 3.0));
  };

  const handleZoomOut = () => {
    setScale((prevScale) => Math.max(prevScale - 0.2, 0.5));
  };

  return (
    <div>
      <Table
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        showHeader={false}
        size='small'
        style={{ border: 'none', background: 'none' }}
        rowClassName={() => 'minimalist-row'}
      />

      <div>
        {offer.equipmentTab.pdfUrl != undefined ? (
          <div className='pdf-div'>
            <div className='pdf-content'>
              <div style={{ position: 'absolute', top: 0, right: 0, zIndex: 1 }}>
                <Button icon={<ZoomOutOutlined />} onClick={handleZoomOut} />
                <Button icon={<ZoomInOutlined />} onClick={handleZoomIn} />
              </div>

              <Document
                file={offer.equipmentTab.pdfUrl}
                onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                onLoadError={(error) => console.error('Error loading PDF:', error)}
              >
                {numPages !== null &&
                  Array.from({ length: numPages }, (_, index) => (
                    <div key={`page_${index + 1}`} className='pdf-page'>
                      <Page
                        pageNumber={index + 1}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                        scale={scale}
                      />
                    </div>
                  ))}
              </Document>
            </div>
          </div>
        ) : (
          <Spin size='large' className='spinner' />
        )}
      </div>
    </div>
  );
};

export default ReviewTab;
